import "./App.css";
import Layout from "./Component/Layout/Layout";
import Aboutus from "./Pages/Aboutus";
import Contact from "./Pages/Contact";
import Faq from "./Pages/Faq";
import Home from "./Pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Projects from "./Pages/Projects";
import Login from "./Pages/Auth/login";
import Signup from "./Pages/Auth/Signup";
import { ToastContainer } from "react-toastify";
import ProjectDetail from "./Pages/ProjectDetail";
import Allpost from "./Pages/Allpost";
import Profile from "./Pages/Auth/Profile";


function App() {
  return (
    <div>
      <div className="mainview">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/about-us" element={<Aboutus />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/detail/:projectid" element={<ProjectDetail />} />
              <Route path="/allpost" element={<Allpost />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
